import { Pipe, PipeTransform } from '@angular/core';
import { ResponseTemplate } from '../common-review-card/review-types';

const PERSONAS = ['professional', 'semi_casual', 'casual'];

@Pipe({
  name: 'filterTemplates',
  standalone: false,
})
export class FilterTemplatesPipe implements PipeTransform {
  static filterTemplates(
    responseTemplates: ResponseTemplate[],
    rating?: number | string,
    taxonomies?: string[],
  ): ResponseTemplate[] {
    if (!responseTemplates) {
      return [];
    }
    rating = rating ? Number(rating) : null;
    taxonomies = !!taxonomies && taxonomies.length > 0 ? taxonomies : null;
    if (!!rating && (rating < 1 || rating > 5)) {
      return [];
    }

    return responseTemplates.filter((responseTemplate) => {
      let ratingMatch = false;
      if (!!rating && !!responseTemplate.ratings) {
        ratingMatch = responseTemplate.ratings.some((r) => r === rating);
      } else {
        ratingMatch = true;
      }

      let categoriesMatch = false;
      let templateCategories = null;
      if (!!responseTemplate && !!responseTemplate.categories) {
        templateCategories = responseTemplate.categories.filter((category) => !!category && category !== '');
      }
      if (!!taxonomies && !!templateCategories && templateCategories.length > 0) {
        categoriesMatch = templateCategories.some(
          (category: string) =>
            PERSONAS.some((persona) => persona === category) ||
            taxonomies.some((taxonomy) => category.includes(taxonomy) || taxonomy.includes(category)),
        );
      } else {
        categoriesMatch = true;
      }
      return ratingMatch && categoriesMatch;
    });
  }

  transform(responseTemplates: ResponseTemplate[], rating?: string, categories?: string[]): ResponseTemplate[] {
    return FilterTemplatesPipe.filterTemplates(responseTemplates, rating, categories);
  }
}
